<template>
  <public-layout class="page-profile">
    <div class="container">
      <div class="section is-left-aligned">
        <h1>My Account</h1>
        <div class="columns">
            <div class="column is-3">

                <aside class="menu">
                    <ul class="menu-list">
                        <li><a @click="section='basic'" href="javascript:;" :class="(section === 'basic')?'is-active':''">Basic Info</a></li>
                        <li><a @click="section='pass'"  href="javascript:;" :class="(section === 'pass')?'is-active':''">Password</a></li>
                    </ul>
                </aside>

            </div>
            <div class="column is-7">

                <div v-if="responseMessage" class="notification is-success has-text-center">
                    {{ responseMessage }}
                </div>

                <div v-if="section === 'basic'">
                    <div class="field">
                        <img class="image is-128x128" v-if="thumb === '' || thumb === null" src="/static/img/profile-placeholder.png">
                        <img class="image is-128x128" v-else :src="thumb" />
                        <input @change="onPictureChange" type="file" ref="pictureFileInput" class="profileImageInput" />
                        <div class="wrapperLinks">
                            <ul class="menu-list">
                                <li><a @click.prevent="changePicture">Change picture</a></li>
                                <li><a @click.prevent="deletePicture">Delete picture</a></li>
                            </ul>
                            <p class="help is-danger thumbError" v-if="haveError('thumb')">{{ getError('thumb') }}</p>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-body">
                        <div class="field">
                            <label class="label">First Name</label>
                            <div class="control">
                            <input :class="'input' + (haveError('firstName') ? ' is-danger':'')" type="text" v-model="firstName">
                            <p class="help is-danger" v-if="haveError('firstName')">{{ getError('firstName') }}</p>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Last Name</label>
                            <div class="control">
                            <input :class="'input' + (haveError('lastName') ? ' is-danger':'')" type="text" v-model="lastName">
                            <p class="help is-danger" v-if="haveError('lastName')">{{ getError('lastName') }}</p>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="field">Username</label>
                        <div class="control">
                        <input :class="'input' + (haveError('username') ? ' is-danger':'')" type="text" v-model="username">
                        <p class="help is-danger" v-if="haveError('username')">{{ getError('username') }}</p>
                        </div>
                    </div>

                    <div class="field">
                        <label class="field">Email</label>
                        <div class="control">
                        <input :class="'input' + (haveError('email') ? ' is-danger':'')" type="text" v-model="email">
                        <p class="help is-danger" v-if="haveError('email')">{{ getError('email') }}</p>
                        </div>
                    </div>
                    <div v-if="successMessage.profile" class="notification is-primary">
                        <button @click.prevent="() => hideSuccess('profile')" class="delete"></button>
                        Profile updated sucessful
                    </div>
                </div>

                <div v-if="section === 'pass'">
                    <div class="field">
                        <label class="label">Password</label>
                        <div class="control">
                        <input :class="'input' + (haveError('password') ? ' is-danger':'')" type="password" v-model="password">
                        <p class="help is-danger" v-if="haveError('password')">{{ getError('password') }}</p>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Confirm Password</label>
                        <div class="control">
                        <input :class="'input' + (haveError('confirmPassword') ? ' is-danger':'')" type="password" v-model="confirmPassword">
                        <p class="help is-danger" v-if="haveError('confirmPassword')">{{ getError('confirmPassword') }}</p>
                        </div>
                    </div>
                    <div v-if="successMessage.password" class="notification is-primary">
                        <button @click.prevent="() => hideSuccess('password')" class="delete"></button>
                        Password updated sucessful
                    </div>

                </div>
                <a @click="save()" class="button button-primary">Save Changes</a>
            </div>
        </div>
      </div>
    </div>
  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import ProfileService from '@/services/ProfileService'
import S3Service from '@/services/S3Service'
import Utils from '@/utils/Utils'

const requiredFields = ['email']

export default {
  components: {
    PublicLayout
  },

  methods: {
    showSuccess (type) {
      this.successMessage[type] = true
    },
    hideSuccess (type) {
      this.successMessage[type] = false
    },
    haveError (field) {
      return [].concat(this.errors).reduce((prev, next) => next.field === field ? true : prev, false)
    },
    getError (field) {
      return [].concat(this.errors).find((element) => element.field === field).message
    },
    save () {
      const handleErrors = err => {
        this.errors = err.response.data.meta.errors
        return true
      }
      if (this.section === 'basic') {
        this.errors = []
        const frontErrors = requiredFields.reduce((prev, next) => {
          if (this[next] === '' || this[next] === null || this[next] === undefined) {
            prev.push({field: next, message: 'This field is required.'})
          }
          return prev
        }, [])

        if (frontErrors.length > 0) {
          this.errors = frontErrors
          return false
        }

        ProfileService.saveBasic(this.firstName, this.lastName, this.email, this.username).then(response => {
          this.firstName = response.data.firstName
          this.lastName = response.data.lastName
          this.username = response.data.username
          this.email = response.data.email
          this.responseMessage = response.meta.message
          this.showSuccess('profile')
          this.$store.dispatch('updateUser', {user: response.data})
          Utils.setUser(response.data)
        }).catch(handleErrors)
      } else if (this.section === 'pass') {
        if (this.password === '') {
          this.errors.push({field: 'password', message: 'The password cannot be blank'})
          return false
        }
        if (this.password !== this.confirmPassword) {
          this.errors.push({field: 'confirmPassword', message: 'The passwords must be the same'})
          return false
        }
        ProfileService.savePassword(this.password).then(response => {
          this.errors = []
          this.showSuccess('password')
          return true
        }).catch(handleErrors)
      }
    },
    changePicture () {
      this.$refs.pictureFileInput.click()
    },
    deletePicture () {
      ProfileService.updateProfileThumbnail('').then((response) => {
        this.$store.dispatch('updateUserThumb', {thumb: ''})
        Utils.setUser(response.data)
        this.thumb = ''
        this.errors = []
      })
    },
    onPictureChange (e) {
      const file = e.target.files[0]
      const extParts = file.name.split('.')
      const ext = extParts[extParts.length - 1]
      const type = file.type.split('/')[0]

      this.errors = []

      if (type !== 'image') {
        this.errors.push({field: 'thumb', message: 'Please introduce a valid image to continue'})
        return false
      }

      S3Service.upload(file)
        .then((id) => ProfileService.updateProfileThumbnail(id + '.' + ext))
        .then((data) => {
          this.$store.dispatch('updateUserThumb', {thumb: data.data.thumb})
          Utils.setUser(data.data)
          this.thumb = data.data.thumb
        })
    }
  },

  created () {},
  data () {
    return {
      successMessage: { profile: false, password: false },
      section: 'basic',
      errors: [],
      responseMessage: '',
      firstName: this.$store.state.user.firstName === null ? '' : this.$store.state.user.firstName,
      lastName: this.$store.state.user.lastName === null ? '' : this.$store.state.user.lastName,
      password: '',
      confirmPassword: '',
      username: this.$store.state.user.username === null ? '' : this.$store.state.user.username,
      thumb: this.$store.state.user.thumb,
      email: this.$store.state.user.email
    }
  }
}
</script>

<style lang="scss">
.page-profile {
    .profileImageInput
    {
        display: none;
    }
    .image {
        display: inline-block;
        vertical-align: top;
        object-fit: cover;
    }
    .thumbError {
        margin-top: 30px;
        margin-bottom: 30px;
        font-size:13px;
    }
    .wrapperLinks {
        display: inline-block;
        vertical-align: top;
        margin-left:1rem;
        ul {
            padding-top: 5px;
            li {
                display: block;
                margin-bottom: 5px;
                a {
                    padding: 0px;
                    color: #e31c79;
                    font-weight: bold;
                    &:hover {
                        background: none;
                        color: #363636;
                    }
                }
            }
        }
    }

    h1{
        margin-bottom: 2rem;
    }

    .menu{
        li{
            a{
                padding: 0.5em 0;
                &.is-active{
                    background: transparent;
                    color: #221c35;
                    font-weight: bolder;
                }
            }
        }
    }

    figure{
        margin-bottom: 1rem;
    }

    .button{
        margin-top: 2rem;
    }

}

</style>



// WEBPACK FOOTER //
// src/pages/ProfilePage.vue